<template>
  <v-select
    :multiple="field.multiple"
    :label="field.label"
    :disabled="field.disabled"
    :items="items"
    :error-messages="errors"
    v-model="fieldValue"
    @change="onChange"
    ref="select"
  >
    <template v-if="field.multiple" v-slot:append-outer>
      <v-btn text @click="onOKClick">OK</v-btn>
    </template>
  </v-select>
</template>

<script>
import validators_mixin from "./../../mixins/validators.mixin";
import entities from "../../api/entities";
import { logState } from "../../classes/logging";
import _, { cloneDeep } from "lodash";

export default {
  name: "ChoiceField",
  props: ["entity_type", "entity", "field", "value", "scope"],
  mixins: [validators_mixin],
  data() {
    return {
      fieldValue: "",
      items: []
    };
  },
  mounted() {
    // window.o = () => console.log(this.entity[this.field.name]);
    // window.s = () => (this.model = []);
    // window.s = () => console.log(this.fieldValue);
    // window.d = () => (this.fieldValue = 2);
    console.log(
      `ChoicesField.mounted [${this.field.name}]`,
      this.field,
      this.value
    );

    // Нужно получить новый объект, а не ссылку
    // в противном случае мы будем модифицировать property, что является грубой
    // ошибкой во Vue
    this.fieldValue = Array.isArray(this.value) ? [...this.value] : this.value;

    if (this.field.choices) this.setItems(this.field.choices);
    this.$root.$on("form_field_change", this.onFormFieldChange);
    this.loadDependedValues();
  },
  destroyed() {
    this.$root.$off("form_field_change", this.onFormFieldChange);
  },
  methods: {
    setItemsFromObject(choices) {
      for (let [key, value] of Object.entries(choices)) {
        const val = this.field.value_type === "int" ? parseInt(key) : key;
        this.items.push({ text: value, value: val });
      }
    },
    setItemsFromArray(choices) {
      for (const choice of choices) {
        const val =
          this.field.value_type === "int" ? parseInt(choice[0]) : choice[0];
        this.items.push({ text: choice[1], value: val });
      }
    },
    setItems(choices) {
      this.items = [];
      if (Array.isArray(choices)) {
        this.setItemsFromArray(choices);
      } else {
        this.setItemsFromObject(choices);
      }
    },
    async loadDependedValues() {
      if (!this.field.depends_on) return;
      console.log("ChoicesField.loadDependedValues on", this.field.name);

      logState("Scope", { color: "#ff0088" }, this.scope);
      let scope = cloneDeep(this.scope) || {};
      for (const name of this.field.depends_on) {
        scope[name] = this.entity[name];
      }
      logState("Scope", { color: "#00ff88" }, scope);
      const result = await entities.depended(
        this.token,
        this.entity_type,
        this.field.name,
        scope
      );
      // this.entity[this.field.name] = null;
      this.setItems(result.choices);
      const possibleValues = _.map(this.items, "value");
      if (!Array.isArray(this.fieldValue)) {
        if (possibleValues.indexOf(this.fieldValue) === -1)
          this.fieldValue = "";
      } else
        this.fieldValue = _.filter(
          this.fieldValue,
          item => possibleValues.indexOf(item) !== -1
        );
    },
    onOKClick() {
      this.$refs.select.blur();
    },
    onChange() {
      // this.entity[this.field.name] = [];
      // this.$emit("input", this.field.name, this.entity[this.field.name]);
      this.showErrors = false; // repeating code in mixin // TODO: ?
      logState(
        "ChoicesField.onChange",
        { color: "green" },
        `Field name: ${this.field.name}`,
        "New value:",
        this.fieldValue
      );
      this.$emit("input", this.fieldValue);
      this.$root.$emit("form_field_change", this.field.name);
    },
    async onFormFieldChange(field_name) {
      console.log(
        "Choices.onFormFieldChange",
        field_name,
        this.field.depends_on
      );
      // Поле зависимо от измененного значения
      if (
        this.field.depends_on &&
        this.field.depends_on.indexOf(field_name) > -1
      )
        this.loadDependedValues();
    }
  }
};
</script>

<style scoped></style>
